<template>
    <v-container>
        <v-layout row>
            <v-flex>
                <GmapMap
                :center="this.marker.position"
                :zoom="14"
                map-type-id="terrain"
                v-bind:class="{'center map-mobile':this.screen.x < 650, 'map-normal':this.screen.x > 650}"
                >
                <GmapMarker
                    :position="marker.position"
                    :clickable="true"
                    :draggable="true"
                    @click="center=marker.position"
                />
                </GmapMap>
            </v-flex>
        </v-layout>
    </v-container> 
</template>

<script>
export default {
    props: {
        marker: Object,
        screen: Object
    }
}
</script>

<style>
.map-mobile{
    height: 15em;
    width: 100%;
}
.map-normal {
    width: 100%;
    height: 20em;
}
</style>



// WEBPACK FOOTER //
// src/components/Maps.vue